import { __assign } from "tslib";
import React, { Fragment } from 'react';
import { IconSVG } from '../icon-svg/icon-svg';
export var IconRefresh = function (SVGprops) {
    return (React.createElement(IconSVG, __assign({}, SVGprops),
        React.createElement(Fragment, null,
            React.createElement("path", { d: "M12 2.5C9.32434 2.5 6.8396 3.56708 5 5.37927V3.5H3V9.5H9V7.5H5.77563C7.27636 5.62762 9.5371 4.5 12 4.5C16.4111 4.5 20 8.08887 20 12.5C20 16.9111 16.4111 20.5 12 20.5C8.94043 20.5 6.19336 18.7969 4.83105 16.0547L3.04003 16.9453C4.74218 20.3711 8.17577 22.5 12 22.5C17.5137 22.5 22 18.0137 22 12.5C22 6.98633 17.5137 2.5 12 2.5Z" }))));
};
